/* One shared, click-to-load Spotify player for collection artwork. */
(() => {
  let panel, slot, status, external, closeButton, controller, controllerPromise, apiPromise;
  let selectedButton, selectedUri = '', loadedUri = '', requestId = 0;

  function spotifyUri(raw) {
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:' || url.hostname !== 'open.spotify.com') return null;
      const match = url.pathname.match(new RegExp('/(track|album|playlist)/([a-zA-Z0-9]{22})(?:/|$)'));
      return match ? 'spotify:' + match[1] + ':' + match[2] : null;
    } catch (_) { return null; }
  }

  function setButtonState(playing) {
    document.querySelectorAll('.lsn-preview-button').forEach(button => {
      const current = button === selectedButton && panel && !panel.hidden;
      button.setAttribute('aria-expanded', String(Boolean(current)));
      button.classList.toggle('is-playing', Boolean(current && playing));
      button.setAttribute('aria-label', (current && playing ? 'Pause ' : 'Preview ') + button.dataset.title + ' on Spotify');
    });
  }

  function ensurePanel() {
    if (panel) return;
    panel = document.createElement('section');
    panel.id = 'lsn-preview-player';
    panel.className = 'lsn-preview-player';
    panel.setAttribute('aria-label', 'Spotify song preview');
    panel.hidden = true;
    panel.innerHTML = '<div class="lsn-preview-player__header"><span>Listen on Spotify</span><button type="button" aria-label="Close song preview">&#215;</button></div><div class="lsn-preview-player__slot"></div><div class="lsn-preview-player__footer"><span role="status">Loading player…</span><a target="_blank" rel="noopener">Open Spotify ↗</a></div>';
    document.body.appendChild(panel);
    slot = panel.querySelector('.lsn-preview-player__slot');
    status = panel.querySelector('[role="status"]');
    external = panel.querySelector('a');
    closeButton = panel.querySelector('button');
    closeButton.addEventListener('click', closePlayer);
  }

  function loadApi() {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Spotify timed out')), 15000);
      window.onSpotifyIframeApiReady = api => { clearTimeout(timer); resolve(api); };
      const script = document.createElement('script');
      script.src = 'https://open.spotify.com/embed/iframe-api/v1';
      script.async = true;
      script.onerror = () => { clearTimeout(timer); reject(new Error('Spotify unavailable')); };
      document.head.appendChild(script);
    });
    return apiPromise;
  }

  function ensureController() {
    if (controllerPromise) return controllerPromise;
    controllerPromise = loadApi().then(api => new Promise((resolve, reject) => {
      const mount = document.createElement('div');
      slot.appendChild(mount);
      const timer = setTimeout(() => reject(new Error('Spotify player timed out')), 15000);
      loadedUri = selectedUri;
      api.createController(mount, { uri: loadedUri, width: '100%', height: 152 }, player => {
        controller = player;
        const frame = slot.querySelector('iframe');
        if (frame) frame.title = 'Spotify song preview';
        player.addListener('ready', () => { clearTimeout(timer); resolve(player); });
        player.addListener('playback_update', event => {
          if (selectedUri.startsWith('spotify:track:') && event.data.playingURI && event.data.playingURI !== selectedUri) return;
          setButtonState(!event.data.isPaused);
          if (panel.hidden) { if (!event.data.isPaused) player.pause(); return; }
          status.textContent = event.data.isPaused ? 'Press play in the Spotify player if needed.' : 'Playing on Spotify';
        });
      });
    }));
    return controllerPromise;
  }

  function closePlayer() {
    requestId += 1;
    if (controller) controller.pause();
    panel.hidden = true;
    setButtonState(false);
    if (selectedButton && selectedButton.isConnected) selectedButton.focus({ preventScroll: true });
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('.lsn-preview-button');
    if (!button) return;
    const uri = spotifyUri(button.dataset.spotify);
    if (!uri) return;
    event.preventDefault();
    event.stopPropagation();
    ensurePanel();
    if (!panel.hidden && selectedUri === uri && controller) {
      controller.togglePlay();
      return;
    }
    const thisRequest = ++requestId;
    selectedButton = button;
    selectedUri = uri;
    panel.hidden = false;
    status.textContent = 'Loading player…';
    external.href = 'https://open.spotify.com/' + uri.split(':').slice(1).join('/');
    setButtonState(false);
    closeButton.focus({ preventScroll: true });
    try {
      const player = await ensureController();
      if (thisRequest !== requestId || panel.hidden) return;
      if (loadedUri !== selectedUri) { player.loadEntity(selectedUri); loadedUri = selectedUri; }
      player.play();
      status.textContent = 'Press play in the Spotify player if needed.';
    } catch (_) {
      if (thisRequest === requestId && !panel.hidden) status.textContent = 'Player unavailable. Use Open Spotify.';
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && panel && !panel.hidden) closePlayer();
  });
})();
